import { Injectable } from '@angular/core';
import { Authenticate } from 'src/app/models/auth/authenticate';
import { WebSocketMessageType } from 'src/app/models/enums/websocket-message-type';
import { TaskProgressionNotification } from 'src/app/models/ws/notifications/task-progression-notification';
import { OutputWebSocketMessage } from 'src/app/models/ws/output-websocket-message';
import { WebSocketMessage } from 'src/app/models/ws/websocket-message';
import { environment } from 'src/environments/environment';
import { MemoryService } from '../memory.service';
import { NotificationHandlerService } from './notification-handler.service';

@Injectable({
    providedIn: 'root',
})
export class WebSocketNotificationService {
    baseUrl;

    private socket: WebSocket;

    /**
     * Constructeur
     */
    constructor(
        private notificationHandlerService: NotificationHandlerService,
        protected memoryService: MemoryService
    ) {
        if (environment.production) {
            var loc = window.location;
            if (loc.protocol === 'https:') {
                this.baseUrl = 'wss:';
            } else {
                this.baseUrl = 'ws:';
            }
            this.baseUrl += '//' + loc.host;
        } else {
            this.baseUrl = environment.wsUrl;
        }
    }

    /**
     * Ouverture d'une webSocket
     * @param login : Login de l'utilisateur
     */
    public startSocket(organizationId: string, login: string) {
        const user: Authenticate = this.memoryService.getConnectedUser();

        this.socket = new WebSocket(`${this.baseUrl}/backoffice-notification/ws?user=${login}&organizationId=${organizationId}&token=${user.token.accessToken}`);

        this.socket.addEventListener('open', (ev) => {
            console.warn('!!WEBSOCKET!! - Websocket notification opened', ev);
        });

        this.socket.addEventListener('message', (ev) => {
            var messageWrapper: WebSocketMessage = WebSocketMessage.fromJson(JSON.parse(ev.data));
            switch (messageWrapper.messageType) {
                case WebSocketMessageType.TaskProgression:
                    let taskProgression: TaskProgressionNotification = TaskProgressionNotification.fromJson(JSON.parse(messageWrapper.payload));

                    console.warn(`Réception d'une notification TaskProgressionNotification`, taskProgression);

                    this.notificationHandlerService.handleTaskProgressionNotification(taskProgression);
                    break;
                default:
                    console.error(`Réception d'une notification inconnue`, messageWrapper);
                    break;
            }
        });

        this.socket.addEventListener('close', (ev) => {
            console.warn('!!WEBSOCKET!! - Websocket notification was closed', ev);
            // console.log('Websocket notification reconnecting...');
            // this.startSocket(login);
        });

        this.socket.addEventListener('error', (ev) => {
            console.warn('!!WEBSOCKET!! - Websocket notification raise an error', ev);
            // console.log('Closing Websocket notification ...', ev);
            // this.socket.close();
        });
    }

    /**
     * Arret de la webSocket
     * @param login : Login de l'utilisateur
     */
    public stopSocket(login: string) {
        console.log('!!WEBSOCKET!! - Demande au serveur la deconnexion de la Websocket notification');
        this.sendMessageRequest(new OutputWebSocketMessage('disconnect', null));
    }

    /**
     * Envoi d'une requête par la webSocket;
     * @param req : Requête a envoyé
     */
    public sendMessageRequest(req: OutputWebSocketMessage) {
        var requestAsJson = JSON.stringify(req);
        this.socket.send(requestAsJson);
    }
}
